// src/pages/admin/Logs.jsx
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { logAPI } from '../../services/api';
import { ClipboardList, Loader2 } from 'lucide-react';

export default function Logs() {
  const [logs,    setLogs]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logAPI.getMedications()
      .then(r => setLogs(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Logs">
      <div className="page-header">
        <div>
          <h2 className="page-title">Medication Logs</h2>
          <p className="page-subtitle">Audit trail of all dose calculations</p>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="flex-center" style={{ padding: 64 }}><Loader2 className="spinner" size={32} /></div>
        ) : logs.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon"><ClipboardList size={40} /></div>
            <p>No calculation logs yet</p>
          </div>
        ) : (
          <div className="table-container" style={{ border: 'none', borderRadius: 0 }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Medicine</th>
                  <th>Patient</th>
                  <th>Age</th>
                  <th>Weight</th>
                  <th>Calculated Dose</th>
                  <th>Frequency</th>
                  <th>Calculated By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    <td><strong>{log.medicine_name}</strong></td>
                    <td>{log.patient_name || <span style={{ color: 'var(--gray-400)' }}>Anonymous</span>}</td>
                    <td>{log.age_at_calculation != null ? `${log.age_at_calculation} yrs` : '—'}</td>
                    <td>{log.weight_at_calculation != null ? `${log.weight_at_calculation} kg` : '—'}</td>
                    <td>
                      <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--primary-dark)' }}>
                        {log.calculated_dose} {log.unit}
                      </span>
                    </td>
                    <td>{log.frequency || '—'}</td>
                    <td>{log.calculated_by_name || '—'}</td>
                    <td style={{ fontSize: '0.8125rem', color: 'var(--gray-400)', whiteSpace: 'nowrap' }}>
                      {new Date(log.created_on).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
